// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.actions[data-v-e491e142] {\n  width: 100%;\n  text-align: right;\n  left: 0;\n  right: 0;\n  padding: 5px 15px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
